/* Folliva Clear: product + landing polish (loaded by sections/fcp-setup.liquid).
   1. Story rails (fcp-rail): arrows on a computer when the cards overflow; phones just swipe.
   2. Product gallery inside #fcp: swipe left/right on phones; if the first image is hidden on
      this page, the first visible one becomes active. Uses the theme's own thumb buttons, so
      fl-product.js stays the single owner of the gallery state. */
(function () {
  "use strict";
  if (window.__fcpInit) return;
  window.__fcpInit = true;

  function ready(f) { document.readyState !== "loading" ? f() : document.addEventListener("DOMContentLoaded", f); }
  function visible(el) { return !!(el && el.getClientRects().length); }

  /* ---- 1. rails ---- */
  function initRail(rail) {
    if (rail.__fcp) return; rail.__fcp = true;
    var track = rail.querySelector("[data-fcp-rail-track]");
    var nav = rail.querySelector("[data-fcp-rail-nav]");
    var prev = rail.querySelector("[data-fcp-rail-prev]");
    var next = rail.querySelector("[data-fcp-rail-next]");
    if (!track || !nav) return;
    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
      return card.getBoundingClientRect().width + gap;
    }
    function sync() {
      var over = track.scrollWidth > track.clientWidth + 4;
      nav.hidden = !over;
      if (!over) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
    }
    prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  }

  /* ---- 2. gallery ---- */
  function initGallery(main) {
    if (main.__fcp) return; main.__fcp = true;
    var root = main.closest("[class*='fl-x-']") || document;
    function thumbs() {
      return Array.prototype.filter.call(root.querySelectorAll("[data-fl-gallery-thumbs] .fl-pdp__thumb"), visible);
    }
    var act = main.querySelector(".fl-pdp__slide.is-active");
    if (act && !visible(act)) { var t0 = thumbs()[0]; if (t0) t0.click(); }

    var x0 = 0, y0 = 0, on = false;
    main.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) return;
      on = true; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener("touchend", function (e) {
      if (!on) return; on = false;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
      var list = thumbs();
      if (list.length < 2) return;
      var i = list.findIndex(function (b) { return b.classList.contains("is-active"); });
      if (i < 0) i = 0;
      var j = dx < 0 ? Math.min(list.length - 1, i + 1) : Math.max(0, i - 1);
      if (j !== i) list[j].click();
    }, { passive: true });
  }

  /* ---- 3. the rating line's "#reviews" link: on the landing the reviews section has no
     id="reviews", so jump to the section whose id ends in __reviews instead ---- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest('#fcp a[href="#reviews"]');
    if (!a || document.getElementById("reviews")) return;
    var t = document.querySelector('#fcp [id$="__reviews"]');
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  function init(scope) {
    var s = scope || document;
    Array.prototype.forEach.call(s.querySelectorAll("[data-fcp-rail]"), initRail);
    Array.prototype.forEach.call(s.querySelectorAll("#fcp [data-fl-gallery-main]"), initGallery);
  }
  ready(function () { init(document); });
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
